import React from 'react';
type ErrorProps = {
  error?: any;
};
const Error = (props: ErrorProps) => {
  if( props.error ) {
    return (
      <p>
        We are unable to generate a report. {props.error}
      </p>
    );
  }
  return <></>;
  
};

export default Error;
